const antdTheme = {
	token: {
		colorPrimary: "#1F5A70",
		colorError: "#FB7185",
		colorSuccess: "#10B981",
		borderRadius: 11,
		fontFamily: "Inter, system-ui, sans-serif",
	},
};

export default antdTheme;
